import React from "react";
import { Select, HStack, Text, Portal, createListCollection } from "@commonsku/design-system";
import { WorkflowSelectOption } from "../../../../types";

export type AssigneeStrategySelectProps = {
    value: string;
    options: WorkflowSelectOption[];
    onChange: (value: string) => void;
};

export const AssigneeStrategySelect = ({ value, options, onChange }: AssigneeStrategySelectProps) => {
    const assigneeStrategies = createListCollection({ items: options });
    return (
        <HStack width="full" gap="2">
            <Text fontSize="md" fontWeight="semibold" margin="0!">Create a task for</Text>
            <Select.Root
                width="300px"
                variant="outline"
                size="md"
                collection={assigneeStrategies}
                value={[value]}
                onValueChange={(e) => onChange(e.value[0])}
            >
                <Select.HiddenSelect />
                <Select.Control>
                    <Select.Trigger >
                        <Select.ValueText />
                    </Select.Trigger>
                    <Select.IndicatorGroup>
                        <Select.Indicator />
                    </Select.IndicatorGroup>
                </Select.Control>
                <Portal>
                    <Select.Positioner>
                        <Select.Content>
                            {assigneeStrategies.items.map((strategy) => (
                                <Select.Item item={strategy} key={strategy.value}>
                                    {strategy.label}
                                </Select.Item>
                            ))}
                        </Select.Content>
                    </Select.Positioner>
                </Portal>
            </Select.Root>
        </HStack>
    );
};
